import { render, staticRenderFns } from "./OverOns.vue?vue&type=template&id=05757c9e"
import script from "./OverOns.vue?vue&type=script&lang=js"
export * from "./OverOns.vue?vue&type=script&lang=js"
import style0 from "./OverOns.vue?vue&type=style&index=0&id=05757c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports